import React from 'react';
import WidgetMachinesSection from 'components/quote_builder_widget/sections/WidgetMachinesSection';

const HOT_STAMPING_MACHINE_LABELS = {
  add: 'add_hot_stamping_machine',
  select: 'select_hot_stamping_machine',
  noneAdded: 'no_hot_stamping_machines_enabled',
  noWidgetMaterials: 'no_widget_materials_for_hot_stamping',
  noMachines: 'no_hot_stamping_machines',
  noMachinesForMaterials: 'no_widget_materials_for_hot_stamping',
  notUsed: 'hot_stamping_machine_not_used',
  failedToLoad: 'failed_to_load_hot_stamping',
  failedToUpdate: 'failed_to_update_hot_stamping_machine',
  createNew: 'create_new_hot_stamping_machine',
};

const HotStampingMachinesSection = ({ onChange }) => (
  <WidgetMachinesSection
    machineKey="hot_stamping_machine"
    listUrl="/quote-builder/widgets/hot-stamping"
    listField="machines"
    labels={HOT_STAMPING_MACHINE_LABELS}
    onMachinesChange={onChange}
  />
);

export default HotStampingMachinesSection;
